<template>
    <div class="aldehyd">
        <ul>
            <li>RCHO</li>
            <li>-al</li>
            <li>Oxidation eines primären Alkohols</li>
            <li>endständige Carbonylgruppe</li>
            <li>Reduktion: primärer Alkohol</li>
            <li>Oxidation: Carbonsäure</li>
        </ul>
        <img
            src="@/assets/img/stoffe/aldehyde/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Aldehyde"
            title="Allgemeine Struktur der Aldehyde"
            width="128px"
            height="auto"
        />
    </div>
</template>

<script>
export default {
    name: 'aldehyd',
};
</script>
